import { NgModule, Component } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { FindDealerComponent } from './find-dealer/find-dealer.component';
import { TataMitraBlogsComponent } from './tata-mitra/tata-mitra-blogs/tata-mitra-blogs.component';
import { TataMitraBlogDetailsComponent } from './tata-mitra/tata-mitra-blog-details/tata-mitra-blog-details.component';
// import { BrandPageComponent } from './brand-page/brand-page.component';
import { CustomerStoriesListComponent } from './home/customer-stories-list/customer-stories-list.component';
import { ExploreProductBuildVehicleComponent } from './explore-product-build-vehicle/explore-product-build-vehicle.component';
import { AuthGuard } from './shared/services/auth/auth.guard';
import { ErrorPageComponent } from './shared/components/error-page/error-page.component';
import { OfferDetailsComponent } from './offer-details/offer-details.component';
import { BrandOffersComponent } from './brand-offers/brand-offers.component';
import { BrandpageComponent } from './brandpage/brandpage.component';
import { CategoryComponent } from './category/category.component';
import { VasDashboardTncComponent } from './vas-dashboard-tnc/vas-dashboard-tnc.component';
import { QuotationComponent } from './quotation/quotation.component';
// import { ProductDetailComponent } from './product/product-detail/product-detail.component';
import { FinanceOffersComponent } from './finance-offers/finance-offers.component';
import { KycPopupComponent } from './kyc-popup/kyc-popup.component';
import { OtpPopupComponent } from './otp-popup/otp-popup.component';
import { AiLandingPageComponent } from './ai-landing-page/ai-landing-page.component';
// import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
// import { XmlComponentComponent } from './xml-component/xml-component.component';
const routes: Routes = [
  {
    path: '',
    component: ExploreProductBuildVehicleComponent,
  },
  {
    path: 'welcome',
    component: ExploreProductBuildVehicleComponent,
  },
  {
    path: 'home',
    component:HomeComponent,
    canActivate:[AuthGuard],
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: '',
    children: [
      {
        path: 'fni',
        loadChildren: () => import('./fni-modules/fni-modules.module').then(m => m.FniModulesModule),canActivate:[AuthGuard],
      }
    ]
  },
  {
    path: '',
    loadChildren: () => import('./product/product.module').then(m => m.ProductModule)
  },
  // { path: 'product-details/:lob_seo/:sub_lob/:ppl_seo/:model/:id', component: ProductDetailComponent },

  // { path: 'product-details', component: ProductDetailComponent },
  {
    path: '',canActivate:[AuthGuard],
    loadChildren: () => import('./Post-Login/post-login.module').then(m => m.PostLoginModule)
  },
  {
    path: '',
    // canActivate:[AuthGuard],canActivateChild:[AuthGuard],
    loadChildren: () => import('./configurator-app/configurator-app.module').then(m => m.ConfiguratorAppModule)
  },
  {
    path: '',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
  },
  {
    path: '',
    canActivate:[AuthGuard],
    loadChildren: () => import('./new-advance-search/new-advance-search.module').then(m => m.NewAdvanceSearchModule)
  },
  {
    path: '',
    loadChildren: () => import('./explore-page/explore-page.module').then(m => m.ExplorePageModule)
  },
  {
    path: '',
    loadChildren: () => import('./popular-comparison/compare.module').then(m => m.CompareModule)
  },
  {
    path: '',
    loadChildren: () => import('./footer/footer.module').then(m => m.FooterModule),
  },
  {
    path: 'page-not-found',
    component: ErrorPageComponent,
  },
  {
    path: 'find-dealer',
    component: FindDealerComponent,
  },
  {
    path: 'blogs-and-stories',
    component: TataMitraBlogsComponent,
  },
  {
    path: 'blogs-and-stories/:title/:id',
    component: TataMitraBlogDetailsComponent,
  },

  {
    path: 'customer-stories',
    component: CustomerStoriesListComponent,
  },
  {
    path: 'offer-details',
    component: OfferDetailsComponent,
  },
  {
    path:'verify-otp',
    component:OtpPopupComponent
  },
  {
    path:'verify-kyc',
    component:KycPopupComponent
  },
  { path: 'quote/:quotationType', component: QuotationComponent },
  { path: 'quote', component: QuotationComponent },


  {
    canActivate:[AuthGuard],
    path:'offers',
    component:BrandOffersComponent
  },
  {
    path:'finance-offers',
    component:FinanceOffersComponent
  },
  // {
  //   path: 'privacy-policy',
  //   component: PrivacyPolicyComponent,
  // },
  // {
  //   path: 'brand',
  //   component: BrandPageComponent,
  // },
  { path: 'brand/:brandType', component: BrandpageComponent },
  {
    path: 'category/:categoryType',
    component: CategoryComponent,
  },
  {
    path:'vas-dashboard-t-n-c',
    component:VasDashboardTncComponent
  },
   {
    path: 'landing-page',
    component: AiLandingPageComponent,
  },
  {
    path: '',
    // canActivate:[AuthGuard],
    loadChildren: () => import('./tataok/tataok.module').then(m => m.TataokModule)
  },
  // {
  //   path: 'xml-sitemap',
  //   component: XmlComponentComponent,
  // },
  { path: "**", redirectTo: "page-not-found" }
];



@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    anchorScrolling: "enabled",
    scrollPositionRestoration: "enabled",
    onSameUrlNavigation: "reload",
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
